import { useLocation } from 'react-router-dom';
import { STRINGS, type Lang, type Strings } from './strings';

/** Derives the active language from the route. Anything under /en is English. */
export function useLang(): Lang {
  const { pathname } = useLocation();
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'de';
}

export function useStrings(): Strings {
  return STRINGS[useLang()];
}

/** Builds a route path for the given language (home route). */
export function homePath(lang: Lang): string {
  return lang === 'en' ? '/en' : '/';
}
